import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Input from 'components/atoms/Input';
import Button from 'components/atoms/Button';
import Toast from 'components/molecules/Toast';
import deviceService from 'services/deviceService';

const Wrapper = styled.div`
  padding: 20px;
`;

const SearchRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

const ResultCard = styled.div`
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
`;

const ResultRow = styled.div`
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }
`;

const Label = styled.span`
  font-weight: 600;
  width: 120px;
  color: #555;
`;

const Value = styled.span`
  color: #333;
`;

const ErrorMessage = styled.div`
  color: #d32f2f;
  padding: 10px;
`;

export default function BinLookup() {
  const [binInput, setBinInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleLookup = async () => {
    if (!binInput || binInput.length < 6) {
      Toast({ type: 'error', message: 'Please enter at least 6 digits' });
      return;
    }
    setLoading(true);
    setResult(null);
    try {
      const res = await deviceService.adminLookupBin(binInput.slice(0, 6));
      setResult(res);
    } catch (ex) {
      Toast({ type: 'error', message: ex.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <SearchRow>
        <Input
          placeholder="Enter first 6 digits of card"
          value={binInput}
          onChange={e => setBinInput(e.target.value.replace(/\D/g, '').slice(0, 6))}
          onKeyDown={e => e.key === 'Enter' && handleLookup()}
        />
        <Button type="primary" width={100} onClick={handleLookup} loading={loading}>
          Lookup
        </Button>
      </SearchRow>

      {result && (
        <ResultCard>
          {result.success ? (
            <>
              <ResultRow>
                <Label>BIN:</Label>
                <Value>{result.data?.bin}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Brand:</Label>
                <Value>{result.data?.brand || result.data?.label || '-'}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Type:</Label>
                <Value>{result.data?.type || '-'}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Category:</Label>
                <Value>{result.data?.category || '-'}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Issuer:</Label>
                <Value>{result.data?.issuer || '-'}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Country:</Label>
                <Value>{result.data?.country?.name || result.data?.country || '-'}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Canadian:</Label>
                <Value>{result.data?.isCanadian ? 'Yes' : 'No'}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Debit:</Label>
                <Value>{result.data?.isDebit ? 'Yes' : 'No'}</Value>
              </ResultRow>
              <ResultRow>
                <Label>Credit:</Label>
                <Value>{result.data?.isCredit ? 'Yes' : 'No'}</Value>
              </ResultRow>
            </>
          ) : (
            <ErrorMessage>{result.message || 'BIN not found'}</ErrorMessage>
          )}
        </ResultCard>
      )}
    </Wrapper>
  );
}
